import { useMemo } from "react";
import { Grid } from "@mui/material";
import { TextField } from "../../FormikComponents/TextField";

interface ICalculatedCustomFieldProps {
  propertyName: string;
  label: string;
  evalString: string;
  evalFields: string[];
  formValues: any;
  labelSx?: any;
}

export const CalculatedCustomField = (props: ICalculatedCustomFieldProps): JSX.Element => {
  const { propertyName, label, evalString, evalFields, formValues, labelSx } = props;

  function fauxEval(formula: string): any {
    // Disabling because this is a legacy eval within a function scope, but want the rule elsewhere.
    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    const func = new Function("return " + formula);
    return func();
  }

  const calculatedValue = useMemo(() => {
    // eval string has {fieldName} to be replaced wit field values
    let parsedEvalString = evalString;
    evalFields.forEach((field) => {
      const regex = RegExp(`{${field}}`);
      if (typeof formValues[field] === "number") {
        parsedEvalString = parsedEvalString.replace(regex, formValues[field].toString());
      }
    });
    //Parsing the string for valid inputs is desired, but an eval should be changed to a new function wrapper, for scoping.
    parsedEvalString = parsedEvalString.replace(/[^-()\d/*+.]/g, "");
    try {
      const evaluation = fauxEval(parsedEvalString);
      if (typeof evaluation === "number") {
        return evaluation;
      } else {
        return null;
      }
    } catch (error) {
      // failsafe for eval() failure
      return null;
    }
  }, [evalString, formValues, evalFields]);

  return (
    <Grid item style={{ display: "flex", flexBasis: 0, flexGrow: 1 }}>
      <TextField
        className="field textfield locked"
        label={label}
        labelSx={labelSx}
        name={propertyName}
        //type="number"
        //disabled={true}
        value={calculatedValue?.toString()}
      />
    </Grid>
  );
};
